<template>
  <div class="container-fluid pt-4">
    <div class="row">
      <!-- left -->
      <div class="bd-sidebar col-md-3 col-xl-2 col-12"></div>
      <!-- center -->
      <div class="bd-content col-md-9 col-xl-8 col-12 pb-md-3 ">
        <b-spinner variant="info" label="Spinning" v-if="isLoading"></b-spinner>
        <b-alert :show="!isAnswered">
          <b-button v-show="!isAnswered" size="sm" @click="copyToClipboard">
            Copiar enlace
          </b-button> Esta encuesta aún no ha sido contestada!
        </b-alert>
        <form-wizard
          v-show="!isLoading" 
          @on-complete="sendEntryPoll(form)" 
          @on-change="tabChanged"
          next-button-text="Siguiente"
          back-button-text="Atrás"
          finish-button-text="Enviar"
          color="#133850">
          <template slot="title">
            <h2>Encuesta de ingreso de {{firstName}} {{lastName}}</h2>
            <p v-if="isAnswered">Contestada el {{ answeredDate }}</p>
          </template>
          <tab-content 
            title="Datos personales" 
            icon="ti-user"
            :before-change="() => validate('personalDataPoll')"
          >
            <PersonalDataPollComponent
              ref="personalDataPoll"
              v-model="form"
              @on-validate="onValidate"
              :disabled="!isNutritionist"
            />
          </tab-content>
          <tab-content 
            title="Estado físico" 
            icon="ti-basketball"
            :before-change="() => validate('exercisePoll')"
          >
            <ExercisePollComponent
              ref="exercisePoll"
              v-model="form.exercise_poll"
              @on-validate="onValidate"
              :disabled="isNutritionist"
            />
          </tab-content>
          <tab-content 
            title="Estado nutricional" 
            icon="ti-pulse"
            :before-change="() => validate('nutritionalPoll')"
          >
            <NutritionalPollComponent
              ref="nutritionalPoll"
              v-model="form.nutritional_poll"
              @on-validate="onValidate"
              :disabled="!isNutritionist"
            />
          </tab-content>
        </form-wizard>
      </div>
      <!-- right -->
      <div class="bd-toc col-xl-2 d-none d-xl-block">
        <div class="side-sticky">
          <ul class="section-nav nav flex-column">
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExercisePollComponent from "../components/entryPoll/ExercisePollComponent";
import NutritionalPollComponent from "../components/entryPoll/NutritionalPollComponent";
import PersonalDataPollComponent from "../components/entryPoll/PersonalDataPollComponent";
import pollsService from "../services/pollsService";
import { mapState } from "vuex";

export default {
  name: 'EntryPollAdmin',
  components: {
    ExercisePollComponent,
    NutritionalPollComponent,
    PersonalDataPollComponent
  },
  data: function() {
    return {
      isLoading: true,
      isAnswered: false,
      firstName: "",
      lastName: "",
      form: {
        nutritional_poll: {
          digestive_symptoms: [],
          diet_type: "",
          allergies: [],
          rejected_foods: [],
          junk_food_preference: "",
          daily_consumptions: [],
          weekly_consumptions: [],
        },
        exercise_poll: {
          observation: "",
          exercise_time: null,
          exercise_type: null,
          times_week: null,
          intensity: null,
          place: null,
          tools: null,
          buy_tools: null,
          days: [],
          time_per_day: null,
          exercise_amount: []
        },
      }
    };
  },
  computed: {
    ...mapState(["login"]),
    answeredDate: function () {
      let fullDate = this.form.updated_at
      if (!fullDate) {
        return ""
      }
      let date = fullDate.split("T",1)[0]
      let reordered_date = date.split("-")
      return reordered_date[2] + "-" + reordered_date[1] + "-" + reordered_date[0]
    },
    isNutritionist: function () {
      return this.login.role === "0" || this.login.role === 0
    },
  },
  watch: {
    // eslint-disable-next-line
    "login.token": function(newValue, oldValue) {
      if (!newValue) {
        // eslint-disable-next-line
        this.$router.push({ name: "home" }).catch(err => {});
      }
    },
  },
  methods: {
    updatePoll: function(form) {
      pollsService
      .update_entry_poll({ form: form, id: this.$route.params.id})
      .then(
        data => {
          this.$toasted.success(data.message);
        },
        error => {
          console.log(error)
          this.$toasted.error("Ha ocurrido un error en la encuesta.");
        }
      )
    },
    sendEntryPoll: function(form) {
      this.$toasted.success("Enviando la información...");
      this.isLoading = true;
      pollsService
        .send_entry_poll({ form: form, id: this.$route.params.id, authenticated: true })
        .then(
          data => {
            this.$toasted.success(data.message);
            this.isLoading = false;
            if (this.isNutritionist) {
              this.$router.push({
                name: "diet",
                params: { id: data.id }
              })
            } else {
              this.$router.push({
                name: "program",
                params: { id: data.id }
              });
            }
          },
          error => {
            console.log(error);
            this.$toasted.error("Ha ocurrido un error guardando la encuesta.");
            this.isLoading = false;
          }
        );
    },
    getEntryPoll: function() {
      pollsService
        .get_entry_poll({ id: this.$route.params.id, authenticated: true })
        .then(
          data => {
            this.isAnswered = data.form.is_answered;
            this.isLoading = false;
            this.form = data.form;
            this.$refs.nutritionalPoll.loadData(data.form.nutritional_poll);
            this.$refs.exercisePoll.loadData(data.form.exercise_poll);
            this.$refs.personalDataPoll.loadData(data.form);
            this.firstName = data.first_name;
            this.lastName = data.last_name;
          },
          // eslint-disable-next-line
          error => {
            this.$toasted.error("Ha ocurrido un error cargando la encuesta.");
          }
        );
    },
    validate: function(name) {
      return this.$refs[name].validate()

    },
    onValidate: function(isValid, tabName) {
      if (!isValid) {
        this.$toasted.error("Existen errores en el cuestionario!");
      }
      else if (tabName === "personalDataPoll" && this.isNutritionist) {
        // updates patient's personal data
        this.updatePoll(this.form)
      }
    },
    tabChanged: function() {
      window.scrollTo(0,0);
    },
    copyToClipboard: function() {
      let props = this.$router.resolve({
        name: "entry_poll_user",
        params: { id: this.$route.params.id }
      });
      let vue_scope = this;
      this.$copyText(window.location.origin + "/" + props.href).then(
        // eslint-disable-next-line
        function(e) {
          vue_scope.$toasted.success("Enlace copiado.");
        },
        // eslint-disable-next-line
        function(e) {
          vue_scope.$toasted.error("Error al copiar el enlace.");
        }
      );
    }
  },
  mounted: function() {
    this.getEntryPoll();
  }
};
</script>

<style>
.bd-sidebar {
  border-right: 1px solid #eee;
}
.bd-toc {
  border-left: 1px solid #eee;
}
.no-hover-info {
  border-color: #17a2b8;
  color: #17a2b8;
}
.no-hover-info:hover {
  border-color: #17a2b8;
  color: #17a2b8;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-disabled {
  cursor: not-allowed;
}
.no-login {
  border-radius: 0.3rem;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(23, 162, 184);
  text-align: center;
}
.no-login-content {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.border-green {
  border: 1px solid rgba(23, 162, 184, 0.33);
}
</style>